import React, { FC } from 'react';

import { CobrandImage } from '../CobrandImage/CobrandImage';
import { LinkTarget, StringBoolean, ARIA_LABELS } from '../../modules/constants/constants';
import { CardAwardBadgeProps } from './CardAwardBadge.types';
import { StyledCardAwardBadge } from './CardAwardBadge.styles';

export const CardAwardBadge: FC<CardAwardBadgeProps> = ({
  awardImagePath,
  awardAltText,
  awardUrl,
  awardUrlAriaLabel,
  awardOpeninNewTab,
  customClass = '',
}) => {
  if (!awardImagePath || !awardAltText) {
    return null;
  }

  const imageComponent = (
    <CobrandImage
      defaultImageURL={awardImagePath}
      altText={awardAltText}
      customClass={`award-image ${customClass}`}
      data-testid="card-award-badge-img"
    />
  );

  if (awardUrl) {
    return (
      <StyledCardAwardBadge
        data-component-name="m-cobrand-CardAwardBadge"
        data-testid="card-award-badge"
        className="text-center"
      >
        <a
          href={awardUrl}
          target={awardOpeninNewTab === StringBoolean.TRUE ? LinkTarget.BLANK : LinkTarget.SELF}
          rel={awardOpeninNewTab === StringBoolean.TRUE ? 'noopener noreferrer' : undefined}
          aria-label={awardUrlAriaLabel}
          className="d-inline-block"
          data-testid="award-button-link"
        >
          {imageComponent}
        </a>
      </StyledCardAwardBadge>
    );
  }

  return (
    <StyledCardAwardBadge data-component-name="m-cobrand-CardAwardBadge" data-testid="card-award-badge">
      {imageComponent}
    </StyledCardAwardBadge>
  );
};

CardAwardBadge.displayName = 'CardAwardBadge';
